// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2d5BV","selected":"Chip_selected__3AMWE"};